import { render, staticRenderFns } from "./TaxonList.vue?vue&type=template&id=82522b50"
import script from "./TaxonList.vue?vue&type=script&lang=js"
export * from "./TaxonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports